










































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Enums
import {
  FilterOperators,
  FilterTypes,
  FILTER_OPERATORS,
  RELATIVE_DATE_OPERATORS,
  OPERATORS_ALLOWED_TO_HAVE_SUBFILTERS,
  FILTER_TYPES_WITH_ARRAY_VALUES
} from "@/data/table";
// Types
import { ISegmentFilter } from "@/models/segments";
import { IOperator } from "@/models/tables";

@Component({
  components: {
    "filter-input": () =>
      import("@/components/app/global/dataFilters/filterInput.vue"),
    "select-operator": () =>
      import("@/components/app/global/dataFilters/selectOperator.vue")
  }
})
export default class SegmentFilter extends Vue {
  @Prop({ required: true })
  public filters!: ISegmentFilter[];

  @Prop({ required: true })
  public filter!: ISegmentFilter;

  @Prop({ required: true })
  public usedFilters!: ISegmentFilter[];

  @Prop({ required: true })
  public disabled!: boolean;

  public localFilter: ISegmentFilter = {} as ISegmentFilter;

  public get options() {
    return this.$_.get(
      this.$_.find(this.filters, ["key", this.localFilter.key]),
      "options",
      []
    );
  }

  public operatorsAllowedToHaveSubFilters: FilterOperators[] = OPERATORS_ALLOWED_TO_HAVE_SUBFILTERS;
  public operators: IOperator[] = FILTER_OPERATORS();
  public relative = false;

  public created() {
    this.localFilter = this.$_.cloneDeep(this.filter);
    if (
      this.isDateFilter &&
      RELATIVE_DATE_OPERATORS.includes(this.localFilter.subfilters[0].operator)
    ) {
      this.relative = true;
    }

    this.focus();
  }

  @Watch("relative")
  public onRelativeChange() {
    this.localFilter.subfilters[0].operator = this.matchedOperators[0].key;
  }

  public onFilterKeyChanged(filterKey) {
    if (filterKey === this.localFilter.key) {
      return;
    }
    this.localFilter = this.$_.cloneDeep(
      this.$_.find(this.filters, ["key", filterKey]) as ISegmentFilter
    );
    this.localFilter.subfilters = [];
    this.localFilter.subfilters.push({
      operator: this.matchedOperators[0].key,
      value: this.isFilterWithArrayValue ? [] : null
    });
  }

  @Watch("localFilter", { deep: true })
  public onLocalFilterChanged() {
    this.$emit(
      "filterChanged",
      this.filter.key,
      this.$_.cloneDeep(this.localFilter)
    );
  }

  public get isDateFilter() {
    return this.localFilter.type === FilterTypes.DATE;
  }

  public isFilterDisabled(filterKey: string) {
    return (
      filterKey !== this.filter.key &&
      this.$_.some(this.usedFilters, ["key", filterKey])
    );
  }

  public get alreadyUsedOperators() {
    return this.$_.map(this.localFilter.subfilters, subfilter => {
      return subfilter.operator;
    });
  }

  public get canHaveOr() {
    return this.$_.some(this.alreadyUsedOperators, operator =>
      this.operatorsAllowedToHaveSubFilters.includes(operator)
    );
  }

  public get matchedOperators(): IOperator[] {
    if (!this.isDateFilter) {
      return this.$_.filter(this.operators, operator =>
        operator.types.includes(this.localFilter.type)
      );
    }
    const relativeCheck = (operator: IOperator) =>
      this.relative
        ? RELATIVE_DATE_OPERATORS.includes(operator.key)
        : !RELATIVE_DATE_OPERATORS.includes(operator.key);
    return this.$_.filter(
      this.operators,
      operator =>
        operator.types.includes(FilterTypes.DATE) && relativeCheck(operator)
    );
  }

  public get hasEmptyValues() {
    return this.$_.some(this.localFilter.subfilters, subfilter =>
      this.$_.isEmpty(subfilter.value)
    );
  }

  public get isFilterWithArrayValue() {
    return FILTER_TYPES_WITH_ARRAY_VALUES.includes(this.localFilter.type);
  }

  public getFilterLabel(filterKey) {
    return this.$_.get(
      this.$_.find(this.filters, ["key", filterKey]),
      "label",
      ""
    ).toLowerCase();
  }

  public addNewOrFilter() {
    if (this.hasEmptyValues) {
      return;
    }
    this.localFilter.subfilters.push({
      operator: this.matchedOperators[0].key,
      value: this.isFilterWithArrayValue ? [] : null
    });
    this.$emit("subfilterAdded", this.localFilter.key);
    this.focus();
  }

  public focus() {
    this.$nextTick(() => {
      const ref = this.$_.last(this.$refs["field-ref"] as Vue[]);
      const el = this.$_.get(ref, "$el");
      if (el && this.$_.has(el, "querySelector")) {
        el.querySelector("input")?.focus();
      }
    });
  }

  public get categoriseSegmentFilters() {
    const categories: string[] = [];
    this.$_.forEach(this.filters, segmentFilter => {
      if (!segmentFilter.group || categories.includes(segmentFilter.group)) {
        return;
      }
      categories.push(segmentFilter.group);
    });

    return this.$_.map(categories, categoryName => {
      return {
        group: categoryName,
        filters: this.$_.filter(this.filters, ["group", categoryName])
      };
    });
  }

  public removeSubfilter(index: number) {
    this.localFilter.subfilters.splice(index, 1);

    if (!this.localFilter.subfilters.length) {
      this.$emit("filterRemoved", this.localFilter.key);
    }
  }

  public dateFilterChanged({ operator, value }) {
    this.localFilter.subfilters[0].value = value;
    this.localFilter.subfilters[0].operator = operator;
  }

  public onSubOperatorChanged(operator: FilterOperators, value: any) {
    if (this.localFilter.subfilters.length === 1) {
      return;
    }
    if (this.operatorsAllowedToHaveSubFilters.includes(operator)) {
      return;
    }
    this.localFilter.subfilters = [
      {
        value,
        operator
      }
    ];
  }
}
